import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface AIBootcampValueCardProps {
  variant: 'light' | 'dark';
}

const AIBootcampValueCard: React.FC<AIBootcampValueCardProps> = ({ variant }) => {
  const isDark = variant === 'dark';

  const listTextColor = isDark ? "text-slate-200" : "text-muted-foreground";
  const valueColor = isDark ? "text-green-400" : "text-primary";
  const priceColor = isDark ? "text-white" : "text-card-foreground";
  const titleColor = isDark ? "text-white" : "text-card-foreground";
  const footerTextColor = isDark ? "text-slate-300" : "text-muted-foreground";
  const iconColor = isDark ? "text-green-400" : "text-primary";

  return (
    <>
      <h3 className={cn("text-2xl font-semibold pt-8 pb-2 px-8 text-center", titleColor)}>
        What You Get:
      </h3>
      <div className="space-y-4 px-8 pb-6">
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>Daily live sessions (max 10 people)</p>
        </div>
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>3 plug-and-play automation templates (valued ±£950)</p>
        </div>
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>A prompt cheatsheet</p>
        </div>
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>30-min 1:1 strategy session (valued £62.5)</p>
        </div>
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>Our AI product cheatsheet</p>
        </div>
        <div className={cn("flex items-start gap-3", listTextColor)}>
          <CheckCircle2 className={cn("h-5 w-5 mt-0.5 flex-shrink-0", iconColor)} />
          <p>Plus 1 year of support (valued £528)</p>
        </div>
      </div>
      <div className="text-center px-8 pb-6">
        <p className={cn("text-lg font-semibold", priceColor)}>
          (Total value £2,339.5)
        </p>
        <div className="flex items-center justify-center gap-2">
          <p className={cn("text-3xl font-bold", valueColor)}>
            Your Pay: £249
          </p>
          <span className={cn("text-lg line-through", isDark ? "text-slate-400" : "text-muted-foreground")}>
            £499
          </span>
          <span className={cn("px-2 py-1 rounded-full text-sm font-semibold", isDark ? "bg-green-400/20 text-green-400" : "bg-primary/10 text-primary")}>
            50% OFF
          </span>
        </div>
        <p className={cn("text-sm font-semibold mt-1", isDark ? "text-green-400" : "text-primary")}>
          Launch Special Offer
        </p>
      </div>
      <div className="px-8 pb-8">
        <Button 
          className={cn(
            "w-full rounded-full shadow-lg hover:shadow-xl transition-all duration-300",
            "gradient-button hover:scale-105 text-lg font-semibold"
          )}
          size="lg"
          onClick={() => window.open("https://cal.com/niumora-ai/ai-bootcamp", "_blank")}
        >
          Secure Your Spot <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
        <p className={cn("text-center text-sm mt-4", footerTextColor)}>
          Limited spots available. Next cohort starting soon.
        </p>
      </div>
    </>
  );
};

export default AIBootcampValueCard; 